<template>
  <a-spin size="large" />
</template>

<script>
export default {
  name: "preloader",
};
</script>